<h2 class="titleGeneric" mat-dialog-title> {{data.title | translate}}</h2>
<div class="genericDialog">
    {{data.question | translate}}
    <p>{{data.list}}</p>
    <p></p>
    {{data.message | translate}}
</div>

<div mat-dialog-actions class="genericButton" align="end">
    <button class="buttonConfirm" mat-raised-button color="primary"
        [mat-dialog-close]="true">{{'DIALOG.QUESTION.OK' | translate}}</button>
</div>